// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Includes inherited overrides from: core -> theme-stadium-house -> aion-management-stadium-house -> parc-at-roxbury
// Generated: 2026-11-02T15:53:41.594Z
// Counts: 1 design, 97 content, 62 slot group, 2 collection binding, 9 section, 4 style

export const designOverrides = {
  "design._site.color.linkUnderline": {
    "cssVariable": "--vibe-color-link-underline",
    "overrideType": "VALUE",
    "value": "underline",
    "mappedField": null
  }
};

export const contentOverrides = {
  "accessibility-hero.headline": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "accessibility-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Accessibility</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitiesforyou.heading": {
    "overrideType": "VALUE",
    "customValue": "<p>Amenities Built For You</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apply-now-hero.blurb_heading": {
    "overrideType": "VALUE",
    "customValue": "<p>YOUR NEW HOME AWAITS</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apply-now-hero.headline": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "apply-now-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Apply Now</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "audioeye-widget.cta_color": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_primary_color"
  },
  "contact-hero.blurb_heading": {
    "overrideType": "VALUE",
    "customValue": "<p>WE'RE HERE TO HELP</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "contact-hero.headline": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "contact-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Contact Us</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "faq-hero.blurb_heading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Frequently asked questions</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-hero.blurb_heading": {
    "overrideType": "VALUE",
    "customValue": "<p>THE COMFORTS OF HOME</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-hero.headline": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Floor Plans</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanslist.subtitle": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_home_floorplans_blurb"
  },
  "floorplanslist.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Make Yourself At Home</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "footer.cta_banner_headline": {
    "overrideType": "VALUE",
    "customValue": "<h3>Live your best life at <span data-type=\"field-token\" data-field=\"property_name\"></span>.</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-hero.blurb_heading": {
    "overrideType": "VALUE",
    "customValue": "<p>A STILL-SHOT OF YOUR NEW LIFE</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-hero.headline": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Gallery</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Welcome To Parc at Roxbury</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "interactive-map-hero.blurb_heading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Find your space</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "interactive-map-hero.headline": {
    "overrideType": "VALUE",
    "customValue": "<h2>Find your space.</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "interactive-map-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Interactive Map</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-hero.blurb_heading": {
    "overrideType": "VALUE",
    "customValue": "<p>Discover Roxbury Township</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-hero.headline": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Neighborhood</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodsection.heading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Perfect location</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "pet-policy-hero.blurb_heading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Furry friends welcome</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "pet-policy-hero.headline": {
    "overrideType": "VALUE",
    "customValue": "<h2>Because pets are family too.</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "pet-policy-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Pet Policy</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicy.feature_1_title": {
    "overrideType": "VALUE",
    "customValue": "<h3>Pet spa</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicy.feature_2_title": {
    "overrideType": "VALUE",
    "customValue": "<h3>Dog park</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicy.feature_3_title": {
    "overrideType": "VALUE",
    "customValue": "<h3>Pet-friendly restaurants</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicy.heading": {
    "overrideType": "VALUE",
    "customValue": "<h3>Pet policy</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "privacy-policy-hero.headline": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "privacy-policy-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Privacy Policy</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Embrace Your New Life in Our Charming Community</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "resident-access-hero.blurb_heading": {
    "overrideType": "VALUE",
    "customValue": "<p>ACCESS YOUR RESIDENT PORTAL</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "resident-access-hero.headline": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "resident-access-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Resident Login</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "residentreview.heading": {
    "overrideType": "VALUE",
    "customValue": "<h2>What residents say</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "reviews-hero.blurb_heading": {
    "overrideType": "VALUE",
    "customValue": "<h2>In their own words</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "reviews-hero.headline": {
    "overrideType": "VALUE",
    "customValue": "<h2>Hear it from our residents.</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "reviews-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Reviews</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-hero.blurb_heading": {
    "overrideType": "VALUE",
    "customValue": "<p>your perfect apartment is here</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-hero.headline": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Schedule a Tour</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "sitemap-hero.headline": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "sitemap-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Sitemap</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "socialfeedsection.heading": {
    "overrideType": "VALUE",
    "customValue": "<h3>Follow us on social media</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "thank-you-hero.headline": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "thank-you-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Thank You</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour-hero.blurb_heading": {
    "overrideType": "VALUE",
    "customValue": "<p>360° views right here</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour-hero.headline": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Virtual Tours</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "_head.favicon_url": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_fav_icon"
  },
  "amenities-hero.blurb_heading": {
    "overrideType": "VALUE",
    "customValue": "<p>THE CONVENIENCE OF HOME</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenities-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Amenities</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.apartmentHeading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Apartment features</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.communityHeading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Community amenities</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.select_units_disclaimer": {
    "overrideType": "VALUE",
    "customValue": "*In Select Homes",
    "generatedValue": null,
    "mappedField": null
  },
  "elise-chatbot.position_side": {
    "overrideType": "VALUE",
    "customValue": "left",
    "generatedValue": null,
    "mappedField": null
  },
  "featuring/apartments-fitness-center-new-brunswick-nj::hyperlocalhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2>Explore apartments in your area</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuring/apartments-fitness-center-new-brunswick-nj::hyperlocalhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Hyperlocal Page Title</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicycallout.heading": {
    "overrideType": "VALUE",
    "customValue": "<h3>Our Pet Policy</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "scheduletourform.form_block": {
    "overrideType": "VALUE",
    "customValue": "elise-schedule-tour-iframe",
    "generatedValue": null,
    "mappedField": null
  },
  "accessibility-hero.blurb_heading": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "amenities-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Welcome to Parc at Roxbury, where comfort meets convenience in the heart of Roxbury Township, NJ. Choose from stylish <a href=\"https://www.parcatroxbury.com/floor-plans/\">one and two-bedroom floor plans</a> all while enjoying an array of amenities like a refreshing swimming pool, modern fitness center, and vibrant community spaces. Join us today!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenities-hero.headline": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitiesforyou.body": {
    "overrideType": "VALUE",
    "customValue": "<p>Welcome to Parc at Roxbury, where modern living meets nature. Choose from spacious one or two-bedroom floor plans and indulge in amenities like walking trails, a sparkling swimming pool, and a vibrant clubhouse. Enjoy a pet-friendly lifestyle with a dog park and relax in our outdoor lounge. Your new home awaits!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apply-now-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At Parc at Roxbury, your perfect living space awaits with one and two-bedroom floor plans designed for comfort and convenience. Enjoy modern amenities like a fitness center, outdoor lounge, and pet-friendly options, along with walking trails just outside your door. Lease online today and experience the vibrant lifestyle you deserve!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "contact-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At Parc at Roxbury, we offer thoughtfully designed one- and two-bedroom apartments that cater to your lifestyle. Nestled in peaceful Roxbury Township, NJ, our community combines modern comfort with convenient amenities. Have questions? Our leasing team is ready to assist you in finding your perfect home!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "feetransparency.application_fee": {
    "overrideType": "VALUE",
    "customValue": "$50",
    "generatedValue": null,
    "mappedField": null
  },
  "feetransparency.community_amenity_fee": {
    "overrideType": "VALUE",
    "customValue": "$450",
    "generatedValue": null,
    "mappedField": null
  },
  "feetransparency.pet_fee": {
    "overrideType": "VALUE",
    "customValue": "$350",
    "generatedValue": null,
    "mappedField": null
  },
  "feetransparency.pet_rent": {
    "overrideType": "VALUE",
    "customValue": "$50",
    "generatedValue": null,
    "mappedField": null
  },
  "feetransparency.reservation_fee": {
    "overrideType": "VALUE",
    "customValue": "$200",
    "generatedValue": null,
    "mappedField": null
  },
  "feetransparency.security_deposit": {
    "overrideType": "VALUE",
    "customValue": "$750",
    "generatedValue": null,
    "mappedField": null
  },
  "feetransparency.utility_admin_billing_fee": {
    "overrideType": "VALUE",
    "customValue": "$4.53",
    "generatedValue": null,
    "mappedField": null
  },
  "feetransparency.utility_electric": {
    "overrideType": "VALUE",
    "customValue": "Usage-Based (Utilities)",
    "generatedValue": null,
    "mappedField": null
  },
  "feetransparency.utility_gas": {
    "overrideType": "VALUE",
    "customValue": "Usage-Based (Utilities)",
    "generatedValue": null,
    "mappedField": null
  },
  "feetransparency.utility_water_sewer": {
    "overrideType": "VALUE",
    "customValue": "Usage-Based (Utilities)",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At Parc at Roxbury, we offer thoughtfully designed floor plans to suit your lifestyle. Whether you crave the cozy charm of a one-bedroom retreat or the spacious comfort of a two-bedroom haven, each layout is crafted for modern living. Browse our available apartment homes and envision your ideal space today!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At Parc at Roxbury, where comfort meets community, envision your future in stylish one or two-bedroom apartments. Indulge in exceptional amenities like a serene outdoor lounge, vibrant game room, and a refreshing swimming pool. Let your imagination run wild—picture yourself living here and savoring every moment!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>1 - 2 Bedroom Apartments in Roxbury Township , NJ</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Welcome to Parc at Roxbury, where modern living meets vibrant community life. Nestled in scenic Roxbury Township, our apartments offer a perfect blend of comfort and convenience. Enjoy local charm with nearby destinations like Horseshoe Lake Recreation Complex, County College of Morris, and Morris Canal Park, creating endless opportunities for leisure and exploration.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "privacy-policy-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p><span>We value your trust. The following online privacy policy is intended to protect and secure the personally identifiable information (any information by which you can be identified) you provide to our organization online.&nbsp;</span></p><p><span>We collect information from visitors on our Web site through online requests including:</span></p><p><span>The information we collect online includes name, address, city, state, ZIP/postal code, telephone number, e-mail address. In order to continuously improve our service and meet your needs we may also ask you to provide information specific to your organization.&nbsp;</span></p><p><span>We use your information to communicate with you, and understand your needs to provide you with better service. We may use your information to complete a transaction, to update you on projects or to personalize our Web site for you. We also provide you the opportunity to remove your name from our mailing lists, if you desire to do so. Please review the corresponding section of this privacy policy below. n addition, we will not send you e-mail that you have not agreed to receive. We may periodically send you e-mail announcing news and event information.&nbsp;</span></p><p><span>We never sell, rent, lease or exchange your personal information with other organizations. We assure you that the identity of all who contact us through this Web site will be kept confidential.&nbsp;</span></p><p><span>We are committed to ensuring the security of your personal information. To prevent unauthorized access, maintain data accuracy, and ensure the proper use of information, we have established and implemented appropriate physical, electronic and managerial procedures to safeguard and secure the information we collect online.&nbsp;</span></p><p><span>From time to time, we may send a “cookie” to your computer. A cookie is a small piece of data that is sent to your browser from a Web server and stored on your computer’s hard drive. A cookie can’t read data off your hard drive or read cookie files created by other sites. Cookies do not damage your system. We use cookies to recognize you when you return to our sites, or to identify which areas of our network of Web sites you have visited. We may use this information to better personalize the content you see on our sites. Many Web sites place cookies on your hard drive. You can choose whether to accept cookies by changing the settings of your browser. Your browser can refuse all cookies, or show you when a cookie is being sent. If you choose not to accept these cookies, your experience at our site and other Web sites may be diminished and some features may not work as intended.&nbsp;</span></p><p><span>This Web site links to documents located on Web sites maintained by other organizations or individuals. Once you access a link to another Web site, please be aware that we are not responsible for the privacy practices or the content of such Web sites.&nbsp;</span></p><p><span>We give you the opportunity to remove your name from our postal mailing list so that you do not receive any future communications. If you desire to permanently remove your name, you can contact us. If you determine that our information about you is inaccurate or it has changed, you may also modify information by contacting customer service.&nbsp;</span></p><p><span>If you have comments or questions about our online privacy policy, or would like more information about us, or are experiencing technical trouble, please contact us.</span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "privacy-policy-hero.blurb_heading": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "privacypolicycontent.body": {
    "overrideType": "VALUE",
    "customValue": "<p><span>We value your trust. The following online privacy policy is intended to protect and secure the personally identifiable information (any information by which you can be identified) you provide to our organization online.&nbsp;</span></p><p><span>We collect information from visitors on our Web site through online requests including:</span></p><p><span>The information we collect online includes name, address, city, state, ZIP/postal code, telephone number, e-mail address. In order to continuously improve our service and meet your needs we may also ask you to provide information specific to your organization.&nbsp;</span></p><p><span>We use your information to communicate with you, and understand your needs to provide you with better service. We may use your information to complete a transaction, to update you on projects or to personalize our Web site for you. We also provide you the opportunity to remove your name from our mailing lists, if you desire to do so. Please review the corresponding section of this privacy policy below. n addition, we will not send you e-mail that you have not agreed to receive. We may periodically send you e-mail announcing news and event information.&nbsp;</span></p><p><span>We never sell, rent, lease or exchange your personal information with other organizations. We assure you that the identity of all who contact us through this Web site will be kept confidential.&nbsp;</span></p><p><span>We are committed to ensuring the security of your personal information. To prevent unauthorized access, maintain data accuracy, and ensure the proper use of information, we have established and implemented appropriate physical, electronic and managerial procedures to safeguard and secure the information we collect online.&nbsp;</span></p><p><span>From time to time, we may send a “cookie” to your computer. A cookie is a small piece of data that is sent to your browser from a Web server and stored on your computer’s hard drive. A cookie can’t read data off your hard drive or read cookie files created by other sites. Cookies do not damage your system. We use cookies to recognize you when you return to our sites, or to identify which areas of our network of Web sites you have visited. We may use this information to better personalize the content you see on our sites. Many Web sites place cookies on your hard drive. You can choose whether to accept cookies by changing the settings of your browser. Your browser can refuse all cookies, or show you when a cookie is being sent. If you choose not to accept these cookies, your experience at our site and other Web sites may be diminished and some features may not work as intended.&nbsp;</span></p><p><span>This Web site links to documents located on Web sites maintained by other organizations or individuals. Once you access a link to another Web site, please be aware that we are not responsible for the privacy practices or the content of such Web sites.&nbsp;</span></p><p><span>We give you the opportunity to remove your name from our postal mailing list so that you do not receive any future communications. If you desire to permanently remove your name, you can contact us. If you determine that our information about you is inaccurate or it has changed, you may also modify information by contacting customer service.&nbsp;</span></p><p><span>If you have comments or questions about our online privacy policy, or would like more information about us, or are experiencing technical trouble, please contact us.</span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>This is elevated, iconic living in Roxbury Township. The city is all around you when you live at Parc at Roxbury. You’ll be living just steps from incredible dining destinations, entertainment hotspots, a buzzing nightlife scene, and pretty much anything else you’d want to experience. When you’re not living life to the max in an energetic area, you’ll be back at our luxe amenity spaces hanging out and making friends.</p><p>With our high-end one and two bedroom apartment homes, you’ll be further treated to opening your front door to a pet-friendly luxurious retreat. So, welcome home. This is Parc at Roxbury.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "resident-access-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At Parc at Roxbury, your dream apartment awaits! Choose from spacious one and two-bedroom floor plans designed for your lifestyle. Enhance your living experience in beautiful Roxbury Township, NJ. Ready to simplify your life? Access your resident portal to pay rent, schedule maintenance, and more—all at your fingertips!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At Parc at Roxbury, find your ideal oasis with stylish one and two-bedroom floor plans designed for modern living. Nestled in the heart of Roxbury Township, NJ, our vibrant community offers more than just a home—it's a lifestyle. Curious? Schedule a tour and hear directly from our satisfied residents!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "sitemap-hero.blurb_heading": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "thank-you-hero.blurb_heading": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "thankyoucontent.body": {
    "overrideType": "VALUE",
    "customValue": "<p>Thank you for reaching out to Parc at Roxbury! Nestled in beautiful Roxbury Township, NJ, we offer spacious one and two-bedroom floor plans designed for your comfort. Our team is excited to connect with you soon and help you discover your ideal home in our vibrant community.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Welcome to Parc at Roxbury, where comfort meets style in Roxbury Township, NJ. Choose from our thoughtfully designed one and two-bedroom <a href=\"https://www.parcatroxbury.com/floor-plans/\">floor plans</a> that cater to your lifestyle. Ready to envision your new home? Take a virtual tour of our vibrant community and discover your future oasis today!</p>",
    "generatedValue": null,
    "mappedField": null
  }
};

export const slotGroupOverrides = {
  "apply-now-hero.cta_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "FIELD_MAPPING",
        "mappedField": "property_apply_now_url"
      },
      "_target": {
        "type": "VALUE",
        "customValue": "_blank"
      },
      "label": {
        "type": "VALUE",
        "customValue": "Apply Now"
      }
    }
  },
  "floorplanslist.cta_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/floor-plans"
      }
    }
  },
  "contactform.form.submit_button": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/thank-you"
      }
    }
  },
  "footer.cta_secondary_button": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "VALUE",
        "customValue": "Schedule a Tour"
      }
    }
  },
  "footer.emergency_badge": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/01a159e7-a80b-77ee-97d6-e8506cb14dfb.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "2-1-1 New Jersey logo"
      }
    }
  },
  "propertyoverview.cta_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "VALUE",
        "customValue": "Find Your New Home"
      }
    }
  },
  "propertyoverview.cta_secondary": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "VALUE",
        "customValue": "Find Your New Home"
      },
      "url": {
        "type": "VALUE",
        "customValue": "/floor-plans"
      }
    }
  },
  "amenitiesforyou.amenity_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/019fd957-93b7-760c-b283-3b6d44e88375.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Resort-style swimming pool with sundeck, teal umbrellas, and lounge chairs at Parc at Roxbury in Roxbury, NJ."
      },
      "title": {
        "type": "VALUE",
        "customValue": "Swimming Pool with Sundeck"
      }
    }
  },
  "amenitiesforyou.amenity_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/01a19cdd-8a42-7186-b716-550c385841a5.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern apartment complex gym with treadmills, ellipticals, weight machines, and free weights."
      },
      "title": {
        "type": "VALUE",
        "customValue": "Fitness Center with Peloton Bikes"
      }
    }
  },
  "amenitiesforyou.amenity_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/01a19cdd-5928-74e8-b795-e220523ee62f.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Community lounge area with a pool table and bar."
      },
      "title": {
        "type": "VALUE",
        "customValue": "Game Room"
      }
    }
  },
  "amenitiesforyou.amenity_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/019fd957-a2b4-7086-8d76-f7958010089e.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Conference room with a long table, chairs, and wall-mounted TV at Parc at Roxbury in Roxbury, NJ."
      },
      "title": {
        "type": "VALUE",
        "customValue": "Conference Room"
      }
    }
  },
  "amenitieslist.in_home_photo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/01a19cdd-859d-71c8-bdfe-ec9e4698f8ae.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Luxury bedroom with a king-size bed, decorative pillows, and a tray with wine glasses on the bed."
      }
    }
  },
  "amenitieslist.indoor_photo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/01a19cdd-8a42-7186-b716-550c385841a5.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern apartment complex gym with treadmills, ellipticals, weight machines, and free weights."
      }
    }
  },
  "amenitieslist.indoorPhoto1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/019d026a-eb4a-76cf-815f-903ac9415e4e.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Interior community gym with treadmills, stationary bikes, and weight machines."
      }
    }
  },
  "amenitieslist.indoorPhoto2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/019d026a-dd7d-753b-8159-b8038d05b795.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Bright community lounge with a pool table, seating, and a granite countertop island."
      }
    }
  },
  "amenitieslist.indoorPhoto3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/019d026a-2b96-77b8-8b64-ef4c1bfac86c.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern communal lounge with sectional sofa, fireplace, TV, and large windows overlooking an outdoor pool."
      }
    }
  },
  "amenitieslist.inHomePhoto1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/019d026a-aedc-7588-be88-4d905afbec34.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern kitchen with an island, dark cabinets, and stainless-steel appliances."
      }
    }
  },
  "amenitieslist.inHomePhoto2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/019d026a-bfbe-72d6-87dd-6ced98268947.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Bright apartment bedroom with a lattice-pattern headboard, white bedding, and two side lamps by large windows."
      }
    }
  },
  "amenitieslist.inHomePhoto3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/019d026a-b050-71e8-88ff-9c0141ef230a.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern apartment bathroom with a white vanity, dark storage cabinet, and glass shower."
      }
    }
  },
  "amenitieslist.neighborhood_photo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/01a19cf4-4112-72d8-9cdb-6124bf5cdb61.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Exterior view of apartment buildings with parking lot and green space."
      }
    }
  },
  "amenitieslist.neighborhoodPhoto1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/019d026a-cd5b-76ca-8323-ce6052e366a1.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Aerial view of a multi-building apartment community with a paved parking lot."
      }
    }
  },
  "amenitieslist.neighborhoodPhoto2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449166337/019d026a-cd5b-76ca-8323-ce6052e366a1.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Exterior view of a modern apartment building with a parking lot and cars."
      }
    }
  },
  "amenitieslist.neighborhoodPhoto3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449166337/019d026a-eabd-704d-8878-a29079a87846.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Exterior view of modern apartment buildings with parking lot and green space."
      }
    }
  },
  "amenitieslist.outdoor_photo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/019fd957-93b7-760c-b283-3b6d44e88375.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Resort-style outdoor swimming pool lined with teal umbrellas and lounge chairs at Parc at Roxbury in Roxbury, NJ."
      }
    }
  },
  "amenitieslist.outdoorPhoto1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/019d026a-d062-744b-9fde-27dcdd7c6c81.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Outdoor pool area with lounge chairs and teal umbrellas in front of a beige, multi-story apartment building."
      }
    }
  },
  "amenitieslist.outdoorPhoto2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/019d026a-e827-7688-a947-eaa260acf053.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Outdoor communal patio with grills, seating, and umbrellas beside an apartment building"
      }
    }
  },
  "amenitieslist.outdoorPhoto3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/019d026a-eabd-704d-8878-a29079a87846.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Aerial view of a modern apartment complex with multiple buildings, parking spaces, and manicured lawns."
      }
    }
  },
  "feesheet.amenity": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Amenity Fee"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$450"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "One-Time"
      }
    }
  },
  "feesheet.amenity_renewal": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Amenity Renewal"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$400"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Annual"
      }
    }
  },
  "feesheet.application": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Application Fee"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$50"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "One-Time"
      }
    }
  },
  "feesheet.buyout": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Buy-Out Fee"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "2 Months' Rent"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "One-Time"
      }
    }
  },
  "feesheet.electric": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Utility — Electric"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "Usage-Based (Utilities)"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Monthly"
      }
    }
  },
  "feesheet.gas": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Utility — Gas"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "Usage-Based (Utilities)"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Monthly"
      }
    }
  },
  "feesheet.late": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Late Fee"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "10%"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Per Occurrence"
      }
    }
  },
  "feesheet.lockout": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Lockout Fee"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$75"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Per Occurrence"
      }
    }
  },
  "feesheet.nsf": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "NSF Fee"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$50"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Per Occurrence"
      }
    }
  },
  "feesheet.parking_garage": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Garage Parking"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$150"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Monthly"
      }
    }
  },
  "feesheet.pet_fee": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Pet Fee"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$350"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "One-Time"
      },
      "cost_detail": {
        "type": "VALUE",
        "customValue": "Per pet. Max 2."
      }
    }
  },
  "feesheet.pet_rent": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Pet Rent"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$50"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Monthly"
      },
      "cost_detail": {
        "type": "VALUE",
        "customValue": "Per pet. Max 2."
      }
    }
  },
  "feesheet.reservation": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Reservation Deposit"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$200"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "One-Time"
      }
    }
  },
  "feesheet.security": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Security Deposit"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$750*"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "One-Time"
      },
      "cost_detail": {
        "type": "VALUE",
        "customValue": "Deposit amount applies with approved credit and may be higher for conditional approvals"
      }
    }
  },
  "feesheet.transfer": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Transfer Fee"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$500"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Per Occurrence"
      }
    }
  },
  "feesheet.trash": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Trash Service"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$30"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Monthly"
      }
    }
  },
  "feesheet.utility_admin": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Utility Admin / Billing"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$4.66"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Monthly"
      }
    }
  },
  "feesheet.utility_setup": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Utility New Account"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$10"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "One-Time"
      }
    }
  },
  "feesheet.water": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Utility — Water & Sewer"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "Usage-Based (Utilities)"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Monthly"
      }
    }
  },
  "hero.card_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "heading": {
        "type": "VALUE",
        "customValue": "COOL Amenities"
      },
      "text": {
        "type": "VALUE",
        "customValue": "Discover how our community makes life convenient and fun."
      },
      "url": {
        "type": "VALUE",
        "customValue": "/amenities"
      },
      "_target": {
        "type": "VALUE",
        "customValue": "_self"
      }
    }
  },
  "hero.card_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "heading": {
        "type": "VALUE",
        "customValue": "LUXURY HOMES"
      },
      "text": {
        "type": "VALUE",
        "customValue": "Spaces designed for comfort, focus, and everyday living."
      },
      "url": {
        "type": "VALUE",
        "customValue": "/floor-plans"
      },
      "_target": {
        "type": "VALUE",
        "customValue": "_self"
      }
    }
  },
  "hero.card_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "heading": {
        "type": "VALUE",
        "customValue": "APPLY"
      },
      "text": {
        "type": "VALUE",
        "customValue": "Fill out the contact form and be one step closer to applying."
      },
      "url": {
        "type": "VALUE",
        "customValue": "/apply-now"
      },
      "_target": {
        "type": "VALUE",
        "customValue": "_self"
      }
    }
  },
  "neighborhoodhighlights.day_poi_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/019d0268-f3ef-7446-93ee-2dccee2e7905.webp"
      },
      "name": {
        "type": "VALUE",
        "customValue": "Roosters Coffeehouse"
      },
      "category": {
        "type": "VALUE",
        "customValue": "Coffee & Cafe"
      },
      "distance": {
        "type": "VALUE",
        "customValue": "2.7"
      },
      "description": {
        "type": "VALUE",
        "customValue": "Family-owned coffee shop and eatery serving lattes, sandwiches and hot cacao in a cozy space."
      }
    }
  },
  "neighborhoodhighlights.day_poi_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/019d0269-1c34-77ed-892c-285b1f3f78ee.webp"
      },
      "name": {
        "type": "VALUE",
        "customValue": "Marshalls"
      },
      "category": {
        "type": "VALUE",
        "customValue": "Shopping & Retail"
      },
      "distance": {
        "type": "VALUE",
        "customValue": "1.5"
      },
      "description": {
        "type": "VALUE",
        "customValue": "Retail chain offering brand-name clothing, accessories, shoes & housewares."
      }
    }
  },
  "neighborhoodhighlights.day_poi_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/019d0269-4a12-777c-bfaf-4e3e65677b11.webp"
      },
      "name": {
        "type": "VALUE",
        "customValue": "Horseshoe Lake Recreation Complex"
      },
      "category": {
        "type": "VALUE",
        "customValue": "Parks & Outdoors"
      },
      "distance": {
        "type": "VALUE",
        "customValue": "1.2"
      },
      "description": {
        "type": "VALUE",
        "customValue": "Recreation complex featuring a lake with fishing & swimming, a playground, sports facilities & more."
      }
    }
  },
  "neighborhoodhighlights.day_poi_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/019d0268-f5cc-734d-ae85-0207372220ee.webp"
      },
      "name": {
        "type": "VALUE",
        "customValue": "Giancarlo's Bakery"
      },
      "category": {
        "type": "VALUE",
        "customValue": "Bakery & Brunch"
      },
      "distance": {
        "type": "VALUE",
        "customValue": "3"
      },
      "description": {
        "type": "VALUE",
        "customValue": "Bakery specializing in Italian-style cakes, pastries, and deli items."
      }
    }
  },
  "neighborhoodhighlights.day_poi_5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/019d0269-32e9-77f6-82f4-1700f725f8da.webp"
      },
      "name": {
        "type": "VALUE",
        "customValue": "Morris Museum"
      },
      "category": {
        "type": "VALUE",
        "customValue": "Arts & Culture"
      },
      "distance": {
        "type": "VALUE",
        "customValue": "14"
      },
      "description": {
        "type": "VALUE",
        "customValue": "Regional museum near Morristown with rotating art, science and history exhibits plus live theatrical performances."
      }
    }
  },
  "neighborhoodhighlights.day_poi_6": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/019d0269-4ae8-77db-a115-32eb6b22ce88.webp"
      },
      "name": {
        "type": "VALUE",
        "customValue": "Morris Canal Park"
      },
      "category": {
        "type": "VALUE",
        "customValue": "Trails & Recreation"
      },
      "distance": {
        "type": "VALUE",
        "customValue": "2.4"
      },
      "description": {
        "type": "VALUE",
        "customValue": "Wooded park with a lake, hiking trails and remnants of the historic Morris Canal to explore on foot or by bike."
      }
    }
  },
  "neighborhoodhighlights.night_poi_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/019d0269-049c-709d-a2b5-50f8b0b414de.webp"
      },
      "name": {
        "type": "VALUE",
        "customValue": "Muldoon's"
      },
      "category": {
        "type": "VALUE",
        "customValue": "Pub & Nightlife"
      },
      "distance": {
        "type": "VALUE",
        "customValue": "2.6"
      },
      "description": {
        "type": "VALUE",
        "customValue": "Neighborhood Irish pub doling out comfort food such as pot pie and burgers amid a lively atmosphere."
      }
    }
  },
  "neighborhoodhighlights.night_poi_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/019d0269-375b-771f-8bf3-ad2545bbe5ab.webp"
      },
      "name": {
        "type": "VALUE",
        "customValue": "Mayo Performing Arts Center (MPAC)"
      },
      "category": {
        "type": "VALUE",
        "customValue": "Live Entertainment"
      },
      "distance": {
        "type": "VALUE",
        "customValue": "15"
      },
      "description": {
        "type": "VALUE",
        "customValue": "Nonprofit community theater hosting readings, plays, performances & live concerts since 1937."
      }
    }
  },
  "neighborhoodhighlights.night_poi_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/019d0268-fe07-726f-989c-f8e7c70eca3b.webp"
      },
      "name": {
        "type": "VALUE",
        "customValue": "La Gratella Pizza & Restaurant"
      },
      "category": {
        "type": "VALUE",
        "customValue": "Italian Dining"
      },
      "distance": {
        "type": "VALUE",
        "customValue": "3"
      },
      "description": {
        "type": "VALUE",
        "customValue": "Casual eatery supplying pizza, pasta, and other Italian dishes, plus catering."
      }
    }
  },
  "neighborhoodhighlights.night_poi_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/019d0268-fda3-772f-82ee-dda92e87ffe4.webp"
      },
      "name": {
        "type": "VALUE",
        "customValue": "Ichiban Japanese Cuisine & Catering"
      },
      "category": {
        "type": "VALUE",
        "customValue": "Sushi Bar & Lounge"
      },
      "distance": {
        "type": "VALUE",
        "customValue": "3"
      },
      "description": {
        "type": "VALUE",
        "customValue": "Japanese spot dishing up classic rolls, sashimi and tempura options, plus a sushi bar."
      }
    }
  },
  "neighborhoodhighlights.night_poi_5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/019d0269-2be2-72aa-bdf5-77394060c658.webp"
      },
      "name": {
        "type": "VALUE",
        "customValue": "AMC Rockaway 16"
      },
      "category": {
        "type": "VALUE",
        "customValue": "Cinema & Entertainment"
      },
      "distance": {
        "type": "VALUE",
        "customValue": "10"
      },
      "description": {
        "type": "VALUE",
        "customValue": "Multiscreen movie theater at Rockaway Townsquare featuring IMAX, Dolby Cinema and plush recliner seating."
      }
    }
  },
  "neighborhoodhighlights.night_poi_6": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/019d0268-fdaf-7580-8f16-88906140c655.webp"
      },
      "name": {
        "type": "VALUE",
        "customValue": "Cliff's Homemade Ice Cream"
      },
      "category": {
        "type": "VALUE",
        "customValue": "Dessert & Sweets"
      },
      "distance": {
        "type": "VALUE",
        "customValue": "2.1"
      },
      "description": {
        "type": "VALUE",
        "customValue": "Old-school ice cream stand scooping 60-plus homemade flavors, with outdoor picnic tables for warm evenings."
      }
    }
  },
  "propertyoverview.image_hero": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/019d026a-cd84-7232-a20d-8fe7c7c9d595.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Open-concept kitchen with dark cabinets, stainless appliances, and an island with seating beside a living/dining area."
      }
    }
  }
};

export const collectionBindingOverrides = {
  "photogallery.images": {
    "limit": null,
    "hiddenIds": [
      "custom_ef46c604-5932-42ad-9881-cc5d39c5faf3"
    ],
    "orderedIds": [
      "custom_74c673d2-d7f2-46c3-9284-99f967d50dd8",
      "custom_0603453c-9a77-4ac4-858c-c5b9dacc9dc2",
      "custom_0623a3d3-0fd8-4b15-ab4a-de01b1cf2733",
      "custom_967db1ef-62a5-4f68-9faf-005a9db45cc8",
      "custom_13247237-6674-49d7-8f05-0f874c05227c",
      "custom_b66286dd-86d8-4db0-88d9-f4d078108a1a",
      "custom_7f67f191-0b13-43b2-a0c9-b76f9e5a18c0",
      "custom_5c6baf3a-10f6-4c5e-8f43-b26c6dfd12fb",
      "custom_7a7cc7e6-acb9-4034-bb82-b6d6cf9beddc",
      "custom_bce9eabb-6655-4c2a-adb6-94498d380a00",
      "custom_e7e1790c-b290-4cde-b66a-baa8c27f5519",
      "custom_0fdd5844-5ebe-483c-be24-d1e7e1a1cb05",
      "custom_bbf30f9e-7aea-4aa4-afb7-09498fa540b2",
      "custom_1c136785-f0d0-43e5-8868-ee75746f972c",
      "custom_be42e8ec-b8d4-492e-b8e3-ee74a4881339",
      "custom_91e88459-ba0f-41e4-9d8a-878d99ea2770",
      "custom_36ecb060-7b3f-4b5f-b484-05fee66339f7",
      "custom_4b2f5595-441f-4c3c-bcd2-091935212603",
      "custom_ef46c604-5932-42ad-9881-cc5d39c5faf3"
    ],
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "propertyoverview.apartment_photos": {
    "limit": null,
    "hiddenIds": null,
    "orderedIds": [
      "custom_0623a3d3-0fd8-4b15-ab4a-de01b1cf2733",
      "custom_0603453c-9a77-4ac4-858c-c5b9dacc9dc2",
      "custom_5c6baf3a-10f6-4c5e-8f43-b26c6dfd12fb",
      "custom_74c673d2-d7f2-46c3-9284-99f967d50dd8",
      "custom_967db1ef-62a5-4f68-9faf-005a9db45cc8",
      "custom_13247237-6674-49d7-8f05-0f874c05227c",
      "custom_b66286dd-86d8-4db0-88d9-f4d078108a1a",
      "custom_7f67f191-0b13-43b2-a0c9-b76f9e5a18c0"
    ],
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  }
};

export const sectionOverrides = {
  "_global": [
    {
      "sectionId": "apartment-sync-loader",
      "blockId": "apartment-sync-loader",
      "position": 0
    },
    {
      "sectionId": "audioeye-widget",
      "blockId": "audioeye-widget",
      "position": 0
    },
    {
      "sectionId": "google-tag-manager",
      "blockId": "google-tag-manager",
      "position": 0
    },
    {
      "sectionId": "json-ld-schema",
      "blockId": "json-ld-schema",
      "position": 0
    },
    {
      "sectionId": "multihub-lead-capture",
      "blockId": "multihub-lead-capture",
      "position": 0
    },
    {
      "sectionId": "elise-chatbot",
      "blockId": "elise-chatbot",
      "position": 0
    },
    {
      "sectionId": "perq-floor-plan",
      "blockId": "perq-floor-plan",
      "position": 0
    }
  ],
  "accessibility": [
    {
      "sectionId": "audioeye-accessibility",
      "blockId": "audioeye-accessibility",
      "position": 9
    }
  ],
  "apply-now": [
    {
      "sectionId": "realpage-oll",
      "blockId": "realpage-oll",
      "position": 9
    }
  ]
};

export const styleOverrides = {
  "_template:hyperlocal::_section.block:apartment-sync": {
    "properties": {
      "paddingBottom": "50px",
      "backgroundColor": "#ffffff"
    }
  },
  "_section.InteractiveMapSection": {
    "properties": {
      "paddingBottom": "50px",
      "backgroundColor": "#ffffff"
    }
  },
  "_section.PetPolicyCallout": {
    "properties": {
      "paddingTop": "0px"
    }
  },
  "header.address_link": {
    "properties": {
      "paddingTop": "5px"
    }
  }
};
